export { ProductTagsRenderer } from './ProductTagsRenderer'
